import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noRepeatArea'
})
export class NoRepeatAreaPipe implements PipeTransform {

  transform(arr: any): any {
    var obj: any = {};
    for ( var i=0, len=arr.length; i < len; i++ )
        obj[arr[i]['area']] = arr[i];

    arr = new Array();
    for ( var key in obj )
        arr.push(obj[key]);



    return arr

}

}
